import api from './api';

const CACHE_KEY = 'wrg_landing_config_v1';

let memory = null;
let inflight = null;

export function normalizeLandingConfig(raw) {
  return {
    homeLandingEnabled: !!raw?.homeLandingEnabled,
    defaultCupSlug: raw?.defaultCupSlug || 'worldcup',
    heroFeaturedMatch: raw?.heroFeaturedMatch || null,
    heroFeaturedMatchId: raw?.heroFeaturedMatchId || raw?.heroFeaturedMatch?._id || null,
  };
}

export function readLandingConfigCache() {
  if (memory?.data) return memory.data;
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.data || typeof parsed.data !== 'object') return null;
    memory = parsed;
    return parsed.data;
  } catch {
    return null;
  }
}

export function writeLandingConfigCache(data) {
  const rec = { at: Date.now(), data };
  memory = rec;
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(rec));
  } catch {
    // Ignore quota / private-mode failures.
  }
}

/**
 * Shared landing fetch so Navbar and `/` do not compete on a slow connection.
 */
export async function fetchLandingConfig({ timeout = 5000 } = {}) {
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data } = await api.get('/settings/landing', { timeout });
      const payload = normalizeLandingConfig(data);
      writeLandingConfigCache(payload);
      return payload;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}
